import { ConnectorType, ConnectorSource } from '@hum/icm-app/src/state';
import { AvailableServiceInfo } from './base';

export const liftoffDirectConnector: AvailableServiceInfo = {
  label: 'Liftoff',
  icon: require('./liftoff.svg'),
  isBeta: true,
  type: ConnectorType.Liftoff,
  source: ConnectorSource.Capital,
  fields: [
    {
      label: 'Enter your Client Code',
      propertyName: 'client_code',
    },
    {
      label: 'Enter your API Key',
      propertyName: 'api_key',
    },
  ],
  connect: (params) => params,
};
